<span class="badge">Default Badge</span>
<span class="badge badge-sm">Default Badge Small</span>
